var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23399 16.4744L3.21249 9.51734H0.399994V6.53573H3.21249V4.54799C3.21249 1.86534 4.77953 0.57251 7.03691 0.57251C8.11822 0.57251 9.04755 0.657853 9.31837 0.695998V3.49953L7.75277 3.50028C6.52508 3.50028 6.28737 4.11874 6.28737 5.02628V6.53573H9.77499L8.83749 9.51734H6.28736V16.4744H3.23399Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d6824d2a9339ef5825d97c3acd65a0f4.svg";
export { ForwardRef as ReactComponent };